module.exports = __webpack_public_path__ + "static/media/make_ai.79b6388d.png";